import { Component, Input, OnInit } from "@angular/core";
import { OrdersService } from "src/app/pages/orders/services/orders.service";

@Component({
  selector: "app-qrcode",
  templateUrl: "./qrcode.component.html",
  styleUrls: ["./qrcode.component.scss"],
})
export class QrcodeComponent implements OnInit {
  qrInfo: any;

  constructor(private ordersService: OrdersService) {}

  ngOnInit(): void {
    this.qrInfo = this.ordersService.getQrCodeInfo();
    console.log(this.qrInfo);
  }

  print() {
    window.print();
  }
}
